var _style, _g, _g2, _g3, _g4, _g5, _path, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2320.5 464.8",
    style: {
      enableBackground: "new 0 0 2320.5 464.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#003498;}\n\t.st2{fill:#FFCC28;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "turnerfox_logo_blue_purchasing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.2,102.4H273V57.4h189.6v45.1h-67.4v192.2h-56V102.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M639.4,239.3c0,22.5,0.7,40.8,1.5,55.3h-48.3l-2.6-24.3h-1.1c-7,10.6-23.8,28.2-56,28.2c-36.2,0-63-21.8-63-75 v-101h56v92.6c0,25,8.4,40.1,27.8,40.1c15.4,0,24.2-10.2,27.8-18.7c1.5-3.2,1.8-7.4,1.8-11.6V122.5h56V239.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M684.1,179.2c0-25.3-0.7-41.9-1.5-56.7h48l1.8,31.7h1.5c9.2-25,31.1-35.5,48.3-35.5c5.1,0,7.7,0,11.7,0.7v50.3 c-4-0.7-8.8-1.4-15-1.4c-20.5,0-34.4,10.6-38.1,27.1c-0.7,3.5-1.1,7.7-1.1,12v87.3h-55.6V179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M823.2,177.4c0-21.5-0.7-39.8-1.5-54.9H870l2.6,23.6h1.1c7.3-10.9,25.6-27.5,55.3-27.5 c36.6,0,64.1,23.2,64.1,73.9v102.1h-55.6v-95.4c0-22.2-8.1-37.3-28.2-37.3c-15.4,0-24.5,10.2-28.2,20.1c-1.5,3.2-2.2,8.4-2.2,13.4 v99.3h-55.6V177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1080.5,225.6c1.8,22.2,24.5,32.7,50.5,32.7c19,0,34.4-2.5,49.4-7l7.3,36.3c-18.3,7-40.6,10.6-64.8,10.6 c-60.8,0-95.5-33.8-95.5-87.6c0-43.6,28.2-91.9,90.4-91.9c57.8,0,79.8,43.3,79.8,85.9c0,9.2-1.1,17.2-1.8,21.1H1080.5z M1146,189 c0-13-5.9-34.8-31.5-34.8c-23.4,0-32.9,20.4-34.4,34.8H1146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1231,179.2c0-25.3-0.7-41.9-1.5-56.7h48l1.8,31.7h1.5c9.2-25,31.1-35.5,48.3-35.5c5.1,0,7.7,0,11.7,0.7v50.3 c-4-0.7-8.8-1.4-15-1.4c-20.5,0-34.4,10.6-38.1,27.1c-0.7,3.5-1.1,7.7-1.1,12v87.3H1231V179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1602.9,294.6c-5.1-5.3-10.2-10.6-16.1-16.9c-16.1,12-38.4,20.8-67.7,20.8c-59.7,0-86-34.1-86-67.2 c0-31.3,18.7-53.9,46.9-67.9v-1.4c-10.6-11.3-18.7-28.9-18.7-45.8c0-29.9,24.5-62.7,73.9-62.7c38.1,0,67,21.5,67,55.6 c0,23.9-14.6,44.3-48.7,60.9l-0.4,1.4c14.3,15.1,29.3,32.4,41.4,44.3c9.9-14.8,17.6-36.6,20.9-57.7h49.8c-6.6,35.9-19,66.5-41,90.1 c13.9,15.1,28.2,30.6,43.6,46.5H1602.9z M1560.8,247.8c-15.4-14.8-35.5-36.3-55.6-58.1c-10.2,7-19.4,17.2-19.4,32.7 c0,20.1,15.7,37.3,41,37.3C1541.4,259.8,1553.5,254.5,1560.8,247.8z M1511,111.2c0,12,5.9,22.5,16.8,34.1 c17.9-12,27.1-21.1,27.1-34.8c0-11.3-7-23.6-21.6-23.6C1519,86.9,1511,98.9,1511,111.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1768,57.4h150.8v44H1824v54.2h88.6v43.6H1824v95.4h-56V57.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2126.4,206.6c0,63-46.5,91.9-94.4,91.9c-52.3,0-92.6-33.1-92.6-88.7s38.1-91.2,95.5-91.2 C2089.7,118.6,2126.4,154.9,2126.4,206.6z M1996.8,208.4c0,29.6,12.8,51.7,36.6,51.7c21.6,0,35.5-20.8,35.5-51.7 c0-25.7-10.2-51.7-35.5-51.7C2006.6,156.6,1996.8,183,1996.8,208.4z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2194.4,122.5L2212,151c5.1,8.8,9.9,17.6,14.6,25.7h0.7c4.8-9.2,9.2-18,13.9-26.4l15.7-27.8h60.4l-58.9,82 l59.7,90.1h-63l-17.9-31c-5.1-8.4-9.5-17.2-13.9-26h-1.1c-4.4,9.2-9.2,17.6-13.5,26l-16.8,31h-61.1l60.8-87.6l-59.3-84.5H2194.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.7,16.6v80L24,56.6L0,98.5l69.7,40L0,178.5l24,41.9l69.7-40v80h48.7v-80l69.7,40l24-41.9l-69.7-40l69.7-40 l-24-41.9l-69.7,40v-80H93.7z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1459,336.9c6.8-1.1,16.4-2,30-2c13.7,0,23.4,2.5,30,7.6c6.3,4.8,10.5,12.6,10.5,21.8s-3.2,17.1-9,22.4 c-7.6,6.9-18.8,9.9-31.9,9.9c-2.9,0-5.5-0.1-7.6-0.4v33.7h-22V336.9z M1480.9,379.7c1.9,0.4,4.2,0.6,7.4,0.6 c11.8,0,19.1-5.7,19.1-15.4c0-8.7-6.3-13.8-17.3-13.8c-4.5,0-7.6,0.4-9.2,0.8V379.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.6,335.6v54.3c0,16.2,6.4,24.5,17.7,24.5c11.6,0,18-7.8,18-24.5v-54.3h22.1v52.9c0,29.1-15.3,42.9-40.9,42.9 c-24.7,0-39.3-13.1-39.3-43.2v-52.6H1565.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1642.7,336.9c7.1-1.1,17.7-2,29.5-2c14.5,0,24.7,2.1,31.7,7.4c5.8,4.5,9,11.1,9,19.7c0,12-8.9,20.3-17.3,23.2v0.4 c6.8,2.7,10.6,9,13.1,17.6c3.1,10.6,6.1,22.9,8,26.6H1694c-1.6-2.7-3.9-10.4-6.8-22c-2.6-11.7-6.8-15-15.9-15.1h-6.7v37.1h-22 V336.9z M1664.7,377.4h8.7c11.1,0,17.6-5.3,17.6-13.6c0-8.7-6.1-13-16.3-13.1c-5.4,0-8.4,0.4-10,0.7V377.4z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1800.4,427.2c-4.1,2-13.2,4.1-25.2,4.1c-33.9,0-51.3-20.3-51.3-47.1c0-32.2,23.9-50.1,53.5-50.1c11.5,0,20.2,2.2,24.1,4.2 l-4.5,16.9c-4.5-1.8-10.8-3.5-18.6-3.5c-17.6,0-31.3,10.2-31.3,31.2c0,18.9,11.6,30.8,31.4,30.8c6.7,0,14.1-1.4,18.5-3.1 L1800.4,427.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837.2,335.6v36.2h36.5v-36.2h22.1v94.3h-22.1v-39.4h-36.5v39.4h-22.3v-94.3H1837.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1938,405.7l-7,24.2h-23l30-94.3h29.1l30.4,94.3h-23.9l-7.6-24.2H1938z M1962.9,389.7l-6.1-20c-1.7-5.6-3.5-12.6-4.9-18.2 h-0.3c-1.5,5.6-2.9,12.7-4.5,18.2l-5.8,20H1962.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2011.3,407.9c6,2.9,15.1,5.9,24.6,5.9c10.2,0,15.6-4.1,15.6-10.2c0-5.9-4.7-9.2-16.4-13.3c-16.3-5.5-26.9-14.1-26.9-27.8 c0-16.1,14-28.4,37.1-28.4c11.1,0,19.2,2.2,25,4.8l-4.9,17.2c-3.9-1.8-10.9-4.5-20.5-4.5s-14.3,4.2-14.3,9.1c0,6,5.5,8.7,18.2,13.3 c17.3,6.2,25.5,14.8,25.5,28.1c0,15.8-12.7,29.2-39.6,29.2c-11.2,0-22.3-2.8-27.8-5.7L2011.3,407.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2111.4,335.6v94.3h-22.3v-94.3H2111.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130.6,429.9v-94.3h25.9l20.4,34.5c5.8,9.9,11.6,21.7,16,32.3h0.4c-1.5-12.4-1.9-25.2-1.9-39.3v-27.6h20.4v94.3h-23.3 l-20.9-36.4c-5.8-10.1-12.2-22.2-17-33.3l-0.4,0.1c0.6,12.4,0.9,25.7,0.9,41.1v28.4H2130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2312.8,425.5c-6.8,2.2-19.8,5.3-32.7,5.3c-17.9,0-30.8-4.3-39.9-12.7c-9-8.1-14-20.4-13.8-34.3 c0.1-31.3,23.9-49.2,56-49.2c12.7,0,22.4,2.4,27.2,4.6l-4.7,17.1c-5.4-2.2-12.1-4.1-22.8-4.1c-18.5,0-32.4,10.1-32.4,30.5 c0,19.4,12.7,30.9,30.8,30.9c5.1,0,9.2-0.6,10.9-1.4v-19.7h-15.1v-16.6h36.5V425.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f9286882071e385f4fb386a82bade053.svg";
export { ForwardRef as ReactComponent };